export const config = {
  src: [
    'audiosprites/audio.ogg',
    'audiosprites/audio.mp3',
  ],
  sprite: {
    big_win: [
      0,
      3693.4240362811793,
    ],
    button_spin: [
      5000,
      1023.1292517006807,
    ],
    end_free_spin: [
      8000,
      3272.5623582766448,
    ],
    free_bet_big_win: [
      13000,
      1377.2335600907031,
    ],
    free_bet_mega_win: [
      16000,
      2213.151927437643,
    ],
    free_bet_total_win: [
      20000,
      979.591836734695,
    ],
    free_bet_ultra_win: [
      22000,
      1319.1836734693893,
    ],
    free_spin_ambient: [
      25000,
      48888.16326530613,
    ],
    free_spin_music: [
      75000,
      26386.575963718828,
    ],
    free_spin_popup: [
      103000,
      4294.240362811792,
    ],
    free_spin_start: [
      109000,
      4091.0657596371893,
    ],
    inside_buttons: [
      115000,
      155.2834467120192,
    ],
    main_ambient: [
      117000,
      61978.412698412685,
    ],
    main_music: [
      180000,
      141672.19954648527,
    ],
    mega_win: [
      323000,
      3684.716553287956,
    ],
    outside_buttons: [
      328000,
      654.5124716553232,
    ],
    reel_spin: [
      330000,
      1452.6984126983962,
    ],
    reel_stop_01: [
      333000,
      65.30612244898748,
    ],
    reel_stop_02: [
      335000,
      88.52607709752647,
    ],
    reel_stop_03: [
      337000,
      88.52607709752647,
    ],
    reel_stop_04: [
      339000,
      88.52607709752647,
    ],
    reel_stop_05: [
      341000,
      91.42857142859384,
    ],
    regular_win: [
      343000,
      1594.9206349206406,
    ],
    tap_to_play: [
      346000,
      6015.419501133806,
    ],
    ultra_win: [
      354000,
      3536.6893424036334,
    ],
  },
}
